export default "__VITE_ASSET__5ef2ed7c__"